import React, { Component } from 'react'
import {Toast} from 'antd-mobile';
import tools from '@/utils/tool';
import API from './../../config/api';
import httpRequest from '@/utils/httpRequest'
import './index.scss'
import Header from '@/components/Header/header'

export default class index extends Component {
  constructor(props){
    super(props)
    this.state = {
      uuid:'',
      data:{},
    }
  }

  componentDidMount(){
    let url = window.location.href
    let parameter =  tools.getParams(url)
    this.setState({
      uuid:parameter.uuid
    },() => {
      this.getList()
    })
  }

  getList = () => {
    const {uuid} = this.state
    httpRequest({
      url: API.practiceStationDetail,
      type: 'get',
      data: {
        uuid:uuid
      }
    }).done((resp) => {
      if (resp.code === 0) {
        this.setState({
          data:resp.data
        })
      } else {
        Toast.fail(resp.msg || resp.error);
      }
    }).fail(jqXHR => {
      Toast.fail(jqXHR.msg || jqXHR.error);
    })
  }

  render() {
    const {data} = this.state
    return (
      <div>
        {/*头部*/}
			  <Header name={'home'} uuid={''}/>
        <div className='container'>
          <div className="title">{data.title}</div>
          <div dangerouslySetInnerHTML={{
                __html: data.info
          }}/>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/CivilizationPraStationDetail/index.js